import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { TextComponent } from "./components/TextComponent";
import { SimonPuzzleComponent } from "./components/SimonPuzzleComponent";
import { IntroComponent } from "./components/IntroComponent";
import { StartComponent } from "./components/StartComponent";
import { MapComponent } from "./components/MapComponent";
import { EndingComponent } from "./components/EndingComponent";
import { NotepadComponent } from "./components/NotepadComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-start", StartComponent);
window.customElements.define("game-intro", IntroComponent);
window.customElements.define("game-ending", EndingComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("game-text", TextComponent);
window.customElements.define("game-simon-puzzle", SimonPuzzleComponent);
window.customElements.define("game-map", MapComponent);
window.customElements.define("game-notepad", NotepadComponent);
